import { Component, computed, HostListener, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, ResolveEnd, ResolveStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth.service';
import { LoadingState } from 'src/app/shared/components/ui/content-display-card/content-display-card.component';
import { AppConfirmService } from 'src/app/shared/services/app-confirm/app-confirm.service';
import { BreakpointObserverService } from 'src/app/shared/services/breakpoint-observer/breakpoint-observer.service';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { StorageService } from 'src/app/storage.service';
import { Chunk } from 'src/app/views/content/chunk/chunk.dto';
import { CreateChunkService } from 'src/app/views/content/chunk/create-chunk/create-chunk.service';
import { ContentStateService } from 'src/app/views/content/content-state.service';
import { ContentService } from 'src/app/views/content/content.service';
import { CourseSettings } from 'src/app/views/displayer/courses/courses.dto';
import { MySpaceService } from '../../../my-space/my-space.service';
import { CourseDisplayerService } from './course-displayer.service';

@Component({
  selector: 'app-course-displayer',
  templateUrl: './course-displayer.component.html',
  styleUrls: ['./course-displayer.component.scss'],
  standalone: false,
})
export class CourseDisplayerComponent implements OnInit, OnDestroy {
  public contentStateService = inject(ContentStateService);

  private audioActionSubscription: Subscription;
  private audioStatusSubscription: Subscription;
  private createModeSubscription: Subscription;
  // private readModeSubscription: Subscription;
  loading = false;
  content;
  public isModuleLoading = false;
  private moduleLoaderSub: Subscription;
  private layoutConfSub: Subscription;
  private routerEventSub: Subscription;
  private currentChunkSub: Subscription;
  private currentChunkIndexSub: Subscription;
  private currentChunkBeingReadSub: Subscription;
  private chunkSubscription: Subscription;
  lectureCheckEventSub: Subscription;
  translateSub: Subscription;
  private canViewContentSubscription: Subscription;
  private cacheDBSubscription: Subscription;
  public scrollConfig = {};
  public layoutConf: any = {};

  chunk: Chunk;
  vue;
  course;
  courseMenu = [];
  currentSection;
  currentLecture;
  sections = [];
  audioAction;
  createMode: boolean;
  // readMode:boolean;
  editPermission;
  currentChunk;
  currentChunkIndex;
  audioStatus;
  courseJourneyData;
  courseID;
  sectionID;
  lectureID;
  actualName;
  actualDescription;
  canViewCourse = true;
  initCompleted = false;
  courseToRequest;
  reloadingCourse;
  scrollID = 0;
  scrollContainer;
  reloadVideoPage: boolean;

  isReadyForIndexing: Signal<boolean> = this.contentStateService.isReadyForIndexing;
  toastState = toSignal(this.toast.loadingIndicator$, { initialValue: { status: 'idle' } });
  loadingIndicatorState = computed<LoadingState>(() => this.contentStateService.loading());
  private breakpointObserverService = inject(BreakpointObserverService);

  isCompact = computed(() => !this.breakpointObserverService.isLargeScreen());

  isReader = computed(() => {
    const userId = this.authService.getID();
    const course = this.course;
    if (course && course.users) {
      const user = course.users.find((u: any) => (u._id || u.id) === userId);
      return user?.role === 'Reader';
    }
    return false;
  });

  constructor(
    private appService: AppService,
    private route: ActivatedRoute,
    private router: Router,
    private layout: LayoutService,
    private _sanitizer: DomSanitizer,
    private cdService: CourseDisplayerService,
    private aroute: ActivatedRoute,
    private mySpaceService: MySpaceService,
    private translate: TranslateService,
    private authService: AuthService,
    private toast: ToastService,
    private confirmService: AppConfirmService,
    private storageService: StorageService,
    private contentService: ContentService,
    private createChunkService: CreateChunkService
  ) {
    this.chunkSubscription = this.createChunkService.chunk$.subscribe((chunkData) => {
      setTimeout(() => {
        this.chunk = chunkData;
      });
    });
    this.canViewContentSubscription = mySpaceService.canViewContent$.subscribe((value) => (this.canViewCourse = value));

    this.aroute.params.subscribe((params) => {
      this.courseID = params.course;
      this.sectionID = params.section;
      this.lectureID = params.lecture;
      this.getCourse();
    });

    this.routerEventSub = router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((routeChange: NavigationEnd) => {
      this.layout.adjustLayout({ route: routeChange.url });
    });

    this.audioActionSubscription = cdService.audioAction$.subscribe((audioAction) => (this.audioAction = audioAction));

    this.createModeSubscription = this.appService.createMode$.subscribe((createMode) => (this.createMode = createMode));

    this.currentChunkSub = cdService.currentChunk$.subscribe((currentChunk) => (this.currentChunk = currentChunk));
    this.currentChunkIndexSub = cdService.currentChunkIndex$.subscribe((currentChunkIndex) => (this.currentChunkIndex = currentChunkIndex));

    this.appService.editPermiission$.subscribe((permission) => (this.editPermission = permission));

    this.currentChunkBeingReadSub = cdService.currentChunkBeingRead$.subscribe((res) => {});
    this.audioStatusSubscription = cdService.audioStatus$.subscribe((status) => {
      this.audioStatus = status;
    });
    this.lectureCheckEventSub = this.mySpaceService.lectureCheckEvent$.subscribe((res) => {
      // this.getCourseJourneyData();
    });
    this.translateSub = this.translate.onLangChange.subscribe((res) => {
      this.getCourseNameAndDescChunkMainEditions();
      this.getMenuItems();
    });

    this.cacheDBSubscription = this.storageService.updatedCacheData$.subscribe((res) => {
      const isCurrentCourse = Array.isArray(res.id) ? res.id.includes(this.courseID) : res.id === this.courseID;

      if (res.table === 'courses' && isCurrentCourse) {
        this.storageService.find('courses', [this.courseID]).then((courses: any[]) => {
          if (courses.length > 0) {
            this.extractCourseContent(courses[0]);
          }
        });
      }
    });
  }

  // Hidden by default due to background indexing automation
  generateEmbeddingsForCurrentContent(): void {
    if (this.currentLecture && this.currentLecture.content_id) {
      this.contentService.generateEmbeddingsForContentChunks(this.currentLecture.content_id);
    }
  }

  ngOnInit() {
    this.courseID = this.route.snapshot.paramMap.get('course');
    this.sectionID = this.route.snapshot.paramMap.get('section');
    this.lectureID = this.route.snapshot.paramMap.get('lecture');
    // this.getCourse(true);
    this.setVue('text');
    this.layoutConf = this.layout.layoutConf;
    // this.getCourseJourneyData();
    this.route.params.subscribe((params) => {
      this.courseID = params.course;
      this.sectionID = params.section;
      this.lectureID = params.lecture;
    });

    // FOR MODULE LOADER FLAG
    this.moduleLoaderSub = this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
        this.isModuleLoading = true;
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.isModuleLoading = false;
      }
    });
    // let target = document.getElementById("scrollContainer");
    // this.scrollEvent({target})
    this.initCompleted = true;
  }

  languageIsFr() {
    return this.translate.currentLang == 'fr';
  }

  requestIsOngoing(courseID) {
    return (
      this.courseToRequest.requests.findIndex((request) => {
        return request.requesterID == this.authService.userInfo()._id;
      }) != -1
    );
  }

  sendCourseRequest(courseID, approverID) {
    if (this.requestIsOngoing(courseID)) {
      this.toast.snackbar.open(this.translate.instant('Snackbar.RequestAlreadyPresent'), 'Ok', { duration: 2000 });
      return;
    }
    this.contentService.requestCourseAccess({ courseID, approverID }).subscribe(
      (res) => {
        this.searchCoursesById();
      },
      (err) => {
        this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', {
          duration: 2000,
        });
      }
    );
  }

  cancelRequest(courseID) {
    const requestID = this.courseToRequest.requests.find((request) => request.requesterID == this.authService.userInfo()._id)._id;

    this.confirmService.confirm({ message: this.translate.instant('Confirm.CancelRequest') }).subscribe((res) => {
      if (res) {
        this.mySpaceService.cancelRequest({ requestID }).subscribe(
          (res) => {
            this.searchCoursesById();
          },
          (err) => {
            this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', { duration: 2000 });
          }
        );
      }
    });
  }

  getNotification(event) {
    if (event == 'reload') {
      this.getCourse(true);
    }
  }

  getCourseJourneyData() {
    this.mySpaceService.getUserCourseJourney(this.courseID).subscribe((res) => {
      res.completion = Math.floor(res.completion);
      this.courseJourneyData = res;
      this.mySpaceService.passNavigationEvent({});
    });
  }

  scrollEvent(e) {
    this.cdService.passScrollEvent(e);
    if (e) {
      this.scrollContainer = e.target;
    }
  }

  getCourseNameAndDescChunkMainEditions() {
    if (!this.course) {
      return;
    }
    const findEdition = (edition) => edition.language == (this.translate.currentLang || localStorage.getItem('language') || 'fr');
    if (this.course.__name) {
      this.actualName = this.course.__name.editions.find(findEdition).content;
      this.course.actualName = this.actualName;
    }
    if (this.course.__description) {
      this.actualDescription = this.course.__description.editions.find(findEdition).content;
      this.course.actualDescription = this.actualDescription;
    }
    for (let i = 0; i < this.course.sections.length; i++) {
      if (this.course.sections[i].__name) {
        this.course.sections[i].actualName = this.course.sections[i].__name.editions.find(findEdition).content;
      }
      for (let j = 0; j < this.course.sections[i].lectures.length; j++) {
        if (this.course.sections[i].lectures[j].__name) {
          this.course.sections[i].lectures[j].actualName = this.course.sections[i].lectures[j].__name.editions.find(findEdition).content;
        }
      }
    }
    this.searchCoursesById();
  }

  searchCoursesById() {
    this.contentService.searchCoursesById(this.course._id).subscribe((res: Array<any>) => {
      this.courseToRequest = res.find((course) => course._id == this.course._id);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.layout.adjustLayout(event);
  }

  scrollToTop(selector: string) {
    if (document) {
      const element = <HTMLElement>document.querySelector(selector);
      element.scrollTop = 0;
    }
  }

  closeSidebar() {
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed',
    });
  }

  private courseSub: Subscription;

  async getCourse(hardReload = false) {
    if (!this.initCompleted) {
      hardReload = true;
    }
    const course = this.courseID + '';

    if (!course) {
      return;
    }

    if (hardReload) {
      await this.storageService.remove('courses', [course]);
    }

    this.courseSub?.unsubscribe();
    this.courseSub = this.contentService.getTheCourse(course).subscribe({
      next: async (res) => {
        this.extractCourseContent(res);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  extractCourseContent(res) {
    const isSameCourse = this.course && this.course._id === res._id;
    this.reloadingCourse = !isSameCourse;
    if (!isSameCourse) {
      this.currentLecture = null;
    }
    for (let x = 0; x < res.sections.length; x++) {
      res.sections[x].lectures.sort((first, second) => {
        if (first.index < second.index) {
          return -1;
        } else {
          return 1;
        }
      });
    }

    this.course = res;
    this.course.image = this._sanitizer.bypassSecurityTrustResourceUrl('data:audio/mpeg;base64,' + this.course.image);
    this.courseMenu = [
      {
        type: 'separator',
        name: 'Contenu du cours', // TODO translate
      },
    ];
    this.getCourseNameAndDescChunkMainEditions();
    this.getMenuItems();

    setTimeout(() => {
      this.reloadingCourse = false;
      const section = this.sectionID;
      const currentLecture = this.lectureID;
      if (section === 'lectures') {
        this.currentSection = null;
        this.currentLecture = this.course.lectures.find((e) => e._id == currentLecture);
      } else {
        this.currentSection = this.course.sections.find((e) => e._id == section);
        if (this.currentSection) {
          this.currentLecture = this.currentSection.lectures.find((e) => e._id == currentLecture);
        }
      }
      this.cdService.passCourse(res);
    }, 100);
  }

  getMenuItems() {
    this.courseMenu = [];
    if (!this.course) {
      return;
    }
    this.course.sections.forEach((section) => {
      const itemMenu = {
        name: section.actualName || section.name,
        type: 'dropDown',
        tooltip: section.name,
        state: section._id,
        sub: [],
      };

      section.lectures.forEach((lecture) => {
        const hs = typeof lecture.has_resource === 'undefined' ? false : lecture.has_resource;
        const resFileID = typeof lecture.has_resource === 'undefined' ? 'null' : lecture.resource_fileID;
        itemMenu.sub.push({
          name: lecture.actualName || lecture.name,
          has_resource: hs,
          file: resFileID,
          state: lecture._id,
          isEncrypted: lecture.isEncrypted,
          content_id: lecture.content_id || 'no content',
        });
      });

      this.courseMenu.push(itemMenu);
    });
  }

  reloadCourses() {
    this.getCourse();
  }

  setVue(vue) {
    this.vue = vue;
  }

  getLecture(): void {
    const section = this.route.snapshot.paramMap.get('section');
    const currentLecture = this.route.snapshot.paramMap.get('lecture');
    this.currentSection = this.course.sections.find((e) => e._id == section);
    this.currentLecture = this.currentSection.lectures.find((e) => e._id == currentLecture);
  }

  updateSettings(settings: CourseSettings) {
    if (!this.course) return;
    this.course = { ...this.course, settings };
    this.contentService.updateCourseSettings(this.course._id, settings).subscribe({
      next: () => {
        // Updated successfully
      },
      error: (error) => {
        console.error('Failed to update Settings for Course', error);
      },
    });
  }

  ngOnDestroy() {
    this.contentStateService.clear();
    this.chunkSubscription?.unsubscribe();
    this.moduleLoaderSub?.unsubscribe();
    this.layoutConfSub?.unsubscribe();
    this.routerEventSub?.unsubscribe();
    this.audioActionSubscription?.unsubscribe();
    this.createModeSubscription?.unsubscribe();
    this.currentChunkSub?.unsubscribe();
    this.currentChunkIndexSub?.unsubscribe();
    this.currentChunkBeingReadSub?.unsubscribe();
    this.audioStatusSubscription?.unsubscribe();
    this.lectureCheckEventSub?.unsubscribe();
    this.translateSub?.unsubscribe();
    this.mySpaceService.setCanViewContent(true);
    this.canViewContentSubscription?.unsubscribe();
    this.courseSub?.unsubscribe();
    this.cacheDBSubscription?.unsubscribe();
  }
}
